













































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ServiceRequestModel } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { ObjectFactory } from '../../config/objectFactory';
import { Language } from '../../types/entity';
import { required } from 'vuelidate/lib/validators';
import { ModelSelect } from 'vue-search-select';

@Component({
    props: {
        serviceRequest: Object,
    },
    validations() {
        const validations = {
            serviceRequest: {
                transportation: {
                    vehicleType: {
                        required,
                    },
                    conciergeService: {
                        required,
                    },
                    isOxygenTankRequired: {
                        required,
                    },
                    mentalHealth: {
                        required,
                    },
                    caregiver: {
                        required,
                    },
                    rideshareService: {
                        required,
                    },
                    isBariatricServiceRequired: {
                        required,
                    },
                },
                interpretation: {
                    serviceType: {
                        required,
                    },
                    isMedicalInterpretation: {
                        required,
                    },
                },
            },
        };
        if (this.$props.serviceRequest.transportation.mentalHealth === false) {
            delete validations.serviceRequest.transportation.caregiver;
        }
        if (this.$props.serviceRequest.transportation.visitType !== 'Non-Procedure' ||
            this.$props.serviceRequest.transportation.vehicleType !== 'Sedan') {
            delete validations.serviceRequest.transportation.rideshareService;
        }
        if (this.$props.serviceRequest.service.type !== 'Transportation' && this.$props.serviceRequest.service.type !== 'TransInterpreter') {
            delete validations.serviceRequest.transportation.vehicleType;
            delete validations.serviceRequest.transportation.conciergeService;
            delete validations.serviceRequest.transportation.isOxygenTankRequired;
            delete validations.serviceRequest.transportation.mentalHealth;
            delete validations.serviceRequest.transportation.caregiver;
            delete validations.serviceRequest.transportation.rideshareService;
            delete validations.serviceRequest.transportation.isBariatricServiceRequired;
        }
        if (this.$props.serviceRequest.transportation.vehicleType === 'Sedan') {
            delete validations.serviceRequest.transportation.isBariatricServiceRequired;
        }
        if (this.$props.serviceRequest.service.type !== 'Interpretation' && this.$props.serviceRequest.service.type !== 'TransInterpreter') {
            delete validations.serviceRequest.interpretation.serviceType;
            delete validations.serviceRequest.interpretation.isMedicalInterpretation;
        }
        return validations;
    },
    components: {
        ModelSelect,
    },
})
export default class VehicleLanguage extends Vue {
    private languages: Language[] = [];
    private languageOptions: Array<{ value: any, text: any }> = [];
    private interpretationServiceTypes = {
        'Phone': 1,
        'In-Person': 2,
        'Video': 1,
    };

    // This variable is used to manage question number
    private questionCounter = 0;
    private formValidation = {
        isLanguageValid: false,
        isInterpretaionHoursValid: false,
        isFormValid: false,
    };


    public mounted() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.languages) {
            this.languages = serviceRequest.languages;
        }
        if (!serviceRequest.stops.isStop1Valid) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
        } else {
            if (serviceRequest.service.type === 'Transportation') {
                this.questionCounter = 0;
            } else if (serviceRequest.service.type === 'Interpretation') {
                this.questionCounter = 2;
            }
            this.validateForm();
        }

        if (serviceRequest.interpretation) {
            this.getLanguages(this.interpretationServiceTypes[serviceRequest.interpretation.serviceType]);
        }

        if (serviceRequest.transportation && serviceRequest.transportation.visitType === 'Non-Procedure') {
            serviceRequest.transportation.conciergeService = false;
        }
    }
    private async getLanguages(serviceType: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.languages) {
            const response = await ObjectFactory.getRequestService().getLanguages(serviceType,
                this.$store.state.serverUrl);
            if (response.data) {
                this.languages = response.data;
                serviceRequest.languages = response.data;
            }
        }
        if (this.languageOptions.length < 1) {
            this.languages.forEach((language) => {
                const option = {
                    value: language.name,
                    text: language.name,
                };
                this.languageOptions.push(option);
            });
        }
        this.validateForm();
    }

    private validateForm() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.service.type === 'Transportation') {
            this.formValidation.isFormValid = true;
            return;
        } else {
            if (serviceRequest.interpretation) {
                this.formValidation.isFormValid = false;
                if (!serviceRequest.interpretation.language) {
                    this.formValidation.isLanguageValid = false;
                } else {
                    this.formValidation.isLanguageValid = true;
                }
                if ((!serviceRequest.interpretation.isImmediateInterpretation) &&
                    (!serviceRequest.interpretation.estimatedTime.hours
                        || serviceRequest.interpretation.estimatedTime.hours <= 0) &&
                    (!serviceRequest.interpretation.estimatedTime.minutes
                        || serviceRequest.interpretation.estimatedTime.minutes < 30)) {
                    this.formValidation.isInterpretaionHoursValid = false;
                } else {
                    this.formValidation.isInterpretaionHoursValid = true;
                }
                this.formValidation.isFormValid = this.formValidation.isInterpretaionHoursValid
                    && this.formValidation.isLanguageValid;
            }
        }
    }
    private nextStep() {
        this.$props.serviceRequest.stops.isStop2Valid = true;
        this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING });
    }

    private preStep() {
        this.$router.go(-1);
    }
    private selectMentalHealthPatient(value: boolean) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.mentalHealth = value;
        }
    }
    private selectOxygenTank(value: boolean) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.isOxygenTankRequired = value;
        }
    }

    private selectbariatricServices(value: any) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.isBariatricServiceRequired = value;
        }
    }

    private setDefaultHours() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.interpretation) {
            if (serviceRequest.interpretation.serviceType === 'In-Person'
                && serviceRequest.interpretation.estimatedTime.hours < 2) {
                serviceRequest.interpretation.estimatedTime.hours = 2;
            } else if (serviceRequest.interpretation.serviceType !== 'In-Person') {
                if (serviceRequest.interpretation.isImmediateInterpretation) {
                    serviceRequest.interpretation.estimatedTime.hours = 0;
                    serviceRequest.interpretation.estimatedTime.minutes = 15;
                } else {
                    serviceRequest.interpretation.estimatedTime.hours = 1;
                }
            }
        }
        this.validateForm();
    }

    private onLanguageSelected() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.preferredProviderRequired = null as any;
        if (serviceRequest.interpretation && serviceRequest.interpretation.language) {
            ObjectFactory.getOrganizationService()
                .getPreferredProviders(this.$store.state.serverUrl, serviceRequest.interpretation.language)
                .then((response) => {
                    this.$store.commit('SET_PREFERRED_PROVIDER', response.data);
                });
        }
    }
}
